<!-- Unmark Payment Modal -->
<div class="modal fade" id="unmarkPaymentModal" msEscClose
	(escPressed)="onCancel()"
	data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="unmarkPaymentModalLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered">
		<div class="modal-content">

			<div class="modal-body text-center">
				<fa-duotone-icon icon="circle-question" class="confirmation-icon text-info" />

				<div class="pt-4 px-4" [innerHTML]="confirmationMessage()"></div>

				<form [formGroup]="unmarkForm" (keydown.enter)="$event.preventDefault()" class="px-4 py-0 text-start">

					<!-- Notes (optional) -->
					<ms-input-label [labelText]="'Notes'" class="mt-3" />
					<textarea
						id="unmarkPaymentNote"
						formControlName="note"
						maxlength="255"
						rows="3"
						class="form-control"
						[class.is-invalid]="unmarkForm.get('note')?.invalid && unmarkForm.get('note')?.touched"
						[class.is-valid]="unmarkForm.get('note')?.valid && unmarkForm.get('note')?.touched && unmarkForm.get('note')?.value !== ''">
					</textarea>
					@if (unmarkForm.get('note')?.errors?.['maxlength'] && unmarkForm.get('note')?.touched) {
						<div class="error-messages">
							<p class="text-danger text-start pt-1 mb-0">{{ FormValidatorMessages.NoteMaxLength }}</p>
						</div>
					}

					<!-- Send Email Checkbox -->
					<div class="form-check mt-3">
						<input
							type="checkbox"
							id="unmarkPaymentSendEmail"
							formControlName="sendEmail"
							class="form-check-input" />
						<label class="form-check-label" for="unmarkPaymentSendEmail">
							Send email notification
						</label>
					</div>
				</form>
			</div>

			<div class="modal-footer border-0 d-flex justify-content-center pb-4">
				<button type="button" class="btn btn-ms-secondary" (click)="onCancel()" [disabled]="isSubmitting">
					Cancel
				</button>
				<button type="button" class="btn btn-primary" (click)="onSubmit()" [disabled]="isSubmitting">
					@if (isSubmitting) {
						<div class="spinner-border text-light spinner-border-sm" role="status">
							<span class="visually-hidden">Loading...</span>
						</div>
					} @else {
						Unmark Payment
					}
				</button>
			</div>

		</div>
	</div>
</div>

<!-- Info Modal -->
<ms-info-modal #unmarkPaymentInfoRef modalId="unmarkPaymentInfoModal"
	(onConfirm)="infoModalConfirmed()" />

<!-- Esc Confirmation Modal -->
<ms-confirmation-modal
	#unmarkPaymentEscConfirmationRef
	modalId="unmarkPaymentEscConfirmationModal"
	confirmButtonText="Leave"
	cancelButtonText="Stay"
	(confirmed)="onEscConfirmed()"
	(cancelled)="onEscCancelled()"
/>
